export default {
  data() {
    return {
      openTraining: false,
    };
  },
  computed: {},
  methods: {
    openRoute(routeName) {
      this.$router.push({ name: routeName });
      this.showsidebar = false;
    },
    checkCurrentRoute(routeName) {
      return this.$route.name === routeName;
    },
  },
};
